module.exports = __webpack_public_path__ + "static/partner-ddd61ed66fda58bd9076468e83319beb.png";